<template>
  <div class="flex flex-col p-3 bg-g0">
    <div class="flex flex-row pt-2 justify-center items-center justify-between">
      <div class="flex flex-row ">
        {{ $e("Modification du Point") }} {{ this.$root.global.flightedit.currentStepFlightActive + 1 }}
      </div>
      <div class="flex flex-row border-g3 border-l ">
        <select class="text-xs leading-3 inputTxtResized" v-model.number="followType"
          @change.stop.prevent="updateFollowTypeStep" disabled>
          <option v-for="type in arrFollowType" :value="type.id" :key="'itm_followtypedrone_' + type.id">
            {{ type.text }}
          </option>
        </select>
      </div>
    </div>

    <div class="flex flex-row px-5 pt-8 mx-auto controlPanel">
      <!-- <div class="flex flex-start py-4">  -->

      <div class="py-2 flex flex-col">
        <div class="flex">
          <div class="h-full flex flex-col">
            <div class="flex items-end">
              <div class="controlPanelKeybord">
                <div class="relative !w-[60px]">
                  <span>{{ $e("Latitude") }}</span>
                  <input type="number" v-model="latitude" id="lat" @focusout="updateValues"
                    @keyup.enter="updateValues" />
                  <label for="lat"></label>
                </div>
              </div>
            </div>

            <div class="flex items-end mt-0.5">
              <div class="controlPanelKeybord">
                <div class="relative !w-[60px]">
                  <input type="number" v-model="longitude" id="lng" @focusout="updateValues"
                    @keyup.enter="updateValues" />
                  <label for="lng"></label>
                  <span>{{ $e("Longitude") }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="py-2 mx-2 flex flex-col ">
        <div class="flex">
          <div class="  controlPanelKeybord grid grid-rows-2 grid-cols-3 gap-0.5">
            <div @mousedown="visualKey(keys['ROOL-LEFT'], true)" @mouseup="visualKey(keys['ROOL-LEFT'], false)"
              @mouseleave="visualKey(keys['ROOL-LEFT'], false)" :class="{ 'active': keyPressed('ROOL-LEFT') }">
              <span>{{ keys['ROOL-LEFT'] }}</span>
              <svg class="fill-current" width="12" viewBox="0 0 75 89" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M41.8016 0.311534C28.3236 -1.11512 14.9556 5.14154 6.89855 16.4808L0.837321 12.1148L3.18121 32.4374L23.1998 28.223L16.6192 23.4829C16.6192 23.4829 16.6192 23.4829 16.6273 23.4887C17.1894 22.7598 25.9739 11.7965 39.966 13.1253C50.2908 14.1046 59.2083 21.3661 62.5575 31.5675C66.5916 30.9117 70.6117 30.2581 74.6459 29.6023C70.7046 13.6873 57.4583 1.96426 41.8016 0.311534Z" />
                <path d="M67 89L36 23L5 89L36 72.5L67 89Z" />
              </svg>
            </div>
            <div @mousedown="visualKey(keys['MOVE-UP'], true)" @mouseup="visualKey(keys['MOVE-UP'], false)"
              @mouseleave="visualKey(keys['MOVE-UP'], false)" :class="{ 'active': keyPressed('MOVE-UP') }">
              <span>{{ keys['MOVE-UP'] }}</span>
              <svg width="9" class="fill-current -rotate-90" viewBox="0 0 62 100" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M11.83 100L61.83 50L11.83 0L0.170013 11.67L38.5 50L0.170013 88.33L11.83 100Z" />
              </svg>
            </div>
            <div @mousedown="visualKey(keys['ROOL-RIGHT'], true)" @mouseup="visualKey(keys['ROOL-RIGHT'], false)"
              @mouseleave="visualKey(keys['ROOL-RIGHT'], false)" :class="{ 'active': keyPressed('ROOL-RIGHT') }">
              <span>{{ keys['ROOL-RIGHT'] }}</span>
              <svg class="fill-current" width="12" viewBox="0 0 75 89" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M33.3364 0.311534C46.8144 -1.11512 60.1824 5.14154 68.2394 16.4808L74.3007 12.1148L71.9568 32.4374L51.9382 28.223L58.5188 23.4829C58.5188 23.4829 58.5188 23.4829 58.5106 23.4887C57.9486 22.7598 49.1641 11.7965 35.1719 13.1253C24.8472 14.1046 15.9296 21.3661 12.5805 31.5675C8.5464 30.9117 4.52624 30.2581 0.49212 29.6023C4.43341 13.6873 17.6797 1.96426 33.3364 0.311534Z" />
                <path d="M8.13798 89L39.138 23L70.138 89L39.138 72.5L8.13798 89Z" />
              </svg>
            </div>
            <div @mousedown="visualKey(keys['MOVE-LEFT'], true)" @mouseup="visualKey(keys['MOVE-LEFT'], false)"
              @mouseleave="visualKey(keys['MOVE-LEFT'], false)" :class="{ 'active': keyPressed('MOVE-LEFT') }">
              <svg width="9" class="fill-current rotate-180" viewBox="0 0 62 100" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M11.83 100L61.83 50L11.83 0L0.170013 11.67L38.5 50L0.170013 88.33L11.83 100Z" />
              </svg>
              <span>{{ keys['MOVE-LEFT'] }}</span>
            </div>
            <div @mousedown="visualKey(keys['MOVE-DOWN'], true)" @mouseup="visualKey(keys['MOVE-DOWN'], false)"
              @mouseleave="visualKey(keys['MOVE-DOWN'], false)" :class="{ 'active': keyPressed('MOVE-DOWN') }">
              <svg width="9" class="fill-current rotate-90" viewBox="0 0 62 100" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M11.83 100L61.83 50L11.83 0L0.170013 11.67L38.5 50L0.170013 88.33L11.83 100Z" />
              </svg>
              <span>{{ keys['MOVE-DOWN'] }}</span>
            </div>
            <div @mousedown="visualKey(keys['MOVE-RIGHT'], true)" @mouseup="visualKey(keys['MOVE-RIGHT'], false)"
              @mouseleave="visualKey(keys['MOVE-RIGHT'], false)" :class="{ 'active': keyPressed('MOVE-RIGHT') }">
              <svg width="9" class="fill-current" viewBox="0 0 62 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.83 100L61.83 50L11.83 0L0.170013 11.67L38.5 50L0.170013 88.33L11.83 100Z" />
              </svg>
              <span>{{ keys['MOVE-RIGHT'] }}</span>
            </div>
          </div>
          <div class=" ml-1 controlPanelKeybord grid grid-rows-2 grid-cols-1 gap-0.5">
            <div @mousedown="visualKey(keys['DRONE-UP'], true)" @mouseup="visualKey(keys['DRONE-UP'], false)"
              @mouseleave="visualKey(keys['DRONE-UP'], false)" :class="{ 'active': keyPressed('DRONE-UP') }">
              <span>{{ keys['DRONE-UP'] }}</span>
              <svg width="15" class="fill-current -rotate-90" viewBox="0 0 100 100" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M36.85 99.89L100 50.18L37 0.110001V23.16C35.9 23.22 0.89 23.43 0 23.49V76.4H36.85V99.89Z" />
              </svg>
            </div>
            <div @mousedown="visualKey(keys['DRONE-DOWN'], true)" @mouseup="visualKey(keys['DRONE-DOWN'], false)"
              @mouseleave="visualKey(keys['DRONE-DOWN'], false)" :class="{ 'active': keyPressed('DRONE-DOWN') }">
              <svg width="15" class="fill-current rotate-90" viewBox="0 0 100 100" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M36.85 99.89L100 50.18L37 0.110001V23.16C35.9 23.22 0.89 23.43 0 23.49V76.4H36.85V99.89Z" />
              </svg>
              <span>{{ keys['DRONE-DOWN'] }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="py-2 flex flex-col">
        <div class="flex">
          <div class="h-full flex flex-col">
            <div class="flex items-end">
              <div class="controlPanelKeybord">
                <div class="relative !w-[60px]" :key="componentPanelKey">
                  <span style="margin-top:-10px;" v-if="this.getHeightMode() === 'EGM96'">{{ $e("Altitude") }} EGM96</span>
                  <span style="margin-top:-10px;" v-if="this.getHeightMode() === 'aboveGroundLevel'">{{ $e("Altitude") }} AGL</span>
                  <span style="margin-top:-10px;" v-if="this.getHeightMode() === 'relativeToStartPoint'">{{ $e("Altitude") }} ALT</span>
                  <input type="number" min="0" max="1500" v-model="alt" id="alt" @focusout="updateValues"
                    @keyup.enter="updateValues" />
                  <label for="alt">m</label>
                </div>
              </div>
            </div>
            <!-- @change="yawVerif" @keyup="updateValues" -->
            <div class="flex items-end mt-0.5">
              <div class="controlPanelKeybord">
                <div class="relative !w-[60px]">
                  <input type="number" min="-180" max="180" step="any" v-model="yaw" @focusout="updateValues"
                    @keyup.enter="updateValues" id="yaw" />
                  <label for="yaw">°</label>
                  <span>{{ $e("Yaw") }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="py-2 mx-2 flex flex-col">
        <div class="flex">
          <div class="h-full flex flex-col">
            <div class="flex items-end">
              <div class="controlPanelKeybord">
                <div class="relative !w-[60px]">
                  <span>{{ $e("Vitesse") }}</span>
                  <input type="number" min="0" max="100" v-model="speed" @focusout="updateValues"
                    @keyup.enter="updateValues" id="speed" />
                  <label for="speed">m/s</label>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>








      <div class=" ml-4 flex flex-col relative top-[-23px]">
        <div class="flex flex-row  py-1 samewidth " style="min-width: 100px;">
          <button type="button" class="btn text-xs" @click.stop.prevent="insertNewPt(0)">{{ $e("Mettre à jour") }}</button>
        </div>
        <div class="flex flex-row  py-1 samewidth " style="min-width: 100px;">
          <button type="button" class="btn text-xs" @click.stop.prevent="insertNewPt(1)">{{ $e("Insérer avant") }}</button>
        </div>
        <div class="flex flex-row  py-1 samewidth " style="min-width: 100px;">
          <button type="button" class="btn text-xs" @click.stop.prevent="insertNewPt(2)">{{ $e("Insérer après") }}</button>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </div>



</template>

<script>
import { ref } from "vue";
import { bindKey, unbindKey } from '@rwh/keystrokes'
import Map from "@/utils/Map";

export default {
  name: "Flights_Keyboard",
  components: {

  },
  props: {

  },

  setup() {

    return {
      points: ref([]),
      alt: ref(60),
      yaw: ref(0),
      speed: ref(1),
      arrFollowType: ref([
        {
          id: 0,
          text: 'Follow Route',
          keyCss: '',
        },
        {
          id: 1,
          text: 'Manual',
          keyCss: 'ok',
        }
      ]),
      followType: ref(0),
      longitude: ref(0),
      latitude: ref(0),
      pressedKey: ref([]),
      keys: ref({}),
      keysAZERTY: ref({
        'MOVE-UP': 'Z',
        'MOVE-LEFT': 'Q',
        'MOVE-DOWN': 'S',
        'MOVE-RIGHT': 'D',
        'ROOL-LEFT': 'A',
        'ROOL-RIGHT': 'E',
        'DRONE-UP': 'R',
        'DRONE-DOWN': 'F',
        'HIGH-DOWN': 'W',
        'HIGH-UP': 'X',
      }),
      keysQWERTY: ref({
        'MOVE-UP': 'W',
        'MOVE-LEFT': 'A',
        'MOVE-DOWN': 'S',
        'MOVE-RIGHT': 'D',
        'ROOL-LEFT': 'Q',
        'ROOL-RIGHT': 'E',
        'DRONE-UP': 'R',
        'DRONE-DOWN': 'F',
        'HIGH-DOWN': 'Z',
        'HIGH-UP': 'X',
      }),
      componentPanelKey: ref(0),
    }
  },

  mounted() {
    this.keys = this.keysAZERTY; // this.$root.debug ? this.keysQWERTY : this.keysAZERTY;

    this.initKeyboard();
    Map.dynamicmission.selectStep(this.$root.global.flightedit.currentStepFlightActive);
  },

  unmounted() {

    for (let key in this.keys) {
      unbindKey(this.keys[key]);
    }
  },


  methods: {
    forceRerenderKeyBoard() {
      this.componentPanelKey += 1;
    },

    setLstPoints(newLst) {
      this.points = newLst;
    },

    insertNewPt(action) {

      this.updateValues();
      if (action == 0) {
        Map.dynamicmission.updateWaypoint(this.$root.global.flightedit.currentStepFlightActive);
      }
      else if (action == 1) {
        Map.setMapAction({ action: "add", index: this.$root.global.flightedit.currentStepFlightActive, value: [] });
      }
      else if (action == 2) {
        Map.setMapAction({ action: "add", index: this.$root.global.flightedit.currentStepFlightActive + 1, value: [] });
      }
    },

    lngVerif() {
      if (isNaN(parseFloat(this.longitude))) {
        this.longitude = 0;
      }
      else {
        this.longitude = parseFloat(this.longitude);
      }
    },

    latVerif() {
      if (isNaN(parseFloat(this.latitude))) {
        this.latitude = 0;
      }
      else {
        this.latitude = parseFloat(this.latitude);
      }
    },

    altVerif() {
      if (this.alt < 0 || isNaN(parseFloat(this.alt))) {
        this.alt = 0;
      } else if (this.alt > 1500) {
        this.alt = 1500;
      } else {
        this.alt = parseFloat(this.alt);
      }
    },

    yawVerif() {
      if (this.yaw < -180 || isNaN(parseFloat(this.yaw))) {
        this.yaw = -180;
      } else if (this.yaw > 180) {
        this.yaw = 180;
      } else {
        this.yaw = parseFloat(this.yaw);
      }

    },

    speedVerif() {
      if (this.speed < 0 || isNaN(parseFloat(this.speed))) {
        this.speed = 1;
      } else if (this.speed > 100) {
        this.speed = 100;
      } else {
        this.speed = parseFloat(this.speed);
      }

    },

    controlleAlt(v) {
      this.alt += v;
      this.altVerif();
    },

    async drcControl(input) {


      let axe = "";
      let up = "";

      switch (input) {
        case "MOVE-UP":
          axe = "X";
          up = '';
          break;
        case "MOVE-DOWN":
          axe = "X";
          up = '-';
          break;
        case "MOVE-LEFT":
          axe = "Y";
          up = '-';
          break;
        case "MOVE-RIGHT":
          axe = "Y";
          up = '';
          break;
        case "ROOL-LEFT":
          axe = "W";
          up = '-';
          break;
        case "ROOL-RIGHT":
          axe = "W";
          up = '';
          break;
        case "DRONE-UP":
          axe = "H";
          up = '';
          break;
        case "DRONE-DOWN":
          axe = "H";
          up = '-';
          break;
        default:
          break;
      }

    },

    initKeyboard() {
      for (let key in this.keys) {
        if (key == 'HIGH-UP' || key == 'HIGH-DOWN') {
          bindKey(this.keys[key], {
            onPressed: () => this.visualKey(this.keys[key], true),
            onPressedWithRepeat: () => this.controlleAlt(key == 'HIGH-UP' ? 5 : -5),
            onReleased: () => this.visualKey(this.keys[key], false),
          })
        }
        else {
          bindKey(this.keys[key], {
            onPressed: () => { this.drcControl(key); this.visualKey(this.keys[key], true) },
            onReleased: () => this.visualKey(this.keys[key], false),
          })
        }
      }
    },

    visualKey(key, press) {
      if (press && !this.pressedKey.includes(key)) {
        this.pressedKey.push(this.keyboard2Instruction(key))
      }
      else {
        this.pressedKey = this.pressedKey.filter((el) => {
          return el != this.keyboard2Instruction(key);
        });
      }
    },

    keyPressed(key) {
      return this.pressedKey.includes(key)
    },

    keyboard2Instruction(value) {
      return Object.keys(this.keys).find(key => this.keys[key] === value);
    },

    updateValues() {

      this.lngVerif();
      this.latVerif();
      this.yawVerif();
      this.altVerif();
      this.speedVerif();

      Map.dynamicmission.updateDrone(this.longitude, this.latitude, this.alt, this.yaw, this.speed);
    },

    updateFollowTypeStep() {

      Map.dynamicmission.updateWaypointFollowRoute(this.$root.global.flightedit.currentStepFlightActive, this.followType === 1 ? false : true);

      Map.setMapAction({ action: "updateFollow", index: undefined, value: undefined });

    },

    getHeightMode() {
      return Map.dynamicmission.getHeightMode();
    }
  }
}
</script>
